import VerticalCenter from "../WrapCenter/VerticalCenter";
import { Card, Col, Row, Typography } from "antd";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { componentPalette } from "src/theme/component-palette";

const { Title } = Typography;

interface CategoryGroupProps {
  link: string;
  customClass: string;
  new_background: string;
  label: string;
  icon: ReactNode;
}

const CategoryGroup = ({ link, customClass, new_background, label, icon }: CategoryGroupProps) => {
  return (
    <Link to={link}>
      <Card id={"home-card"} hoverable size={"default"} styles={{ body: { padding: 0 } }}>
        <Row className="w-full h-28">
          <Col span={12} className={`rounded-l-md frame-card-one ${customClass}`} style={{ background: componentPalette.white }}>
            <VerticalCenter styles={{ alignItems: "center" }}>{icon}</VerticalCenter>
          </Col>
          <Col
            span={12}
            className={`rounded-r-md flex flex-column items-center justify-center frame-card-two ${customClass}`}
            style={{ background: new_background }}
          >
            <Title level={5} style={{ color: componentPalette.white, textAlign: "center" }}>
              {label}
            </Title>
          </Col>
        </Row>
      </Card>
    </Link>
  );
};

export default CategoryGroup;
